import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

const styles = css`
  .page-divider {
    background-color: ${colors.G2};
    border: 0;
    height: 1px;
    margin: 0 16px;
  }
`;
export default styles;
